// Contenu orienté conversion — freelance full-stack
export const portfolioData = {
  personal: {
    name: "Mathys Waelter",
    title: "Développeur Full-Stack",
    tagline: "Apps web de A à Z — de l'idée à la mise en production",
    description:
      "Je conçois et livre des applications web modernes pour PME et startups : interface, API, base de données et déploiement.",
    email: "mathys.waelter@outlook.com",
    location: "Toulouse, France · Remote",
    availability: "Disponible pour nouveaux projets",
    responseTime: "Réponse sous 24–48h",
    github: "https://github.com/MathysWaelter",
    linkedin: "https://www.linkedin.com/in/mathys-waelter-1055631a4/",
    malt: "https://www.malt.fr/profile/mathyswaelter",
    profileImage: "mathys-profile.webp",
    calUsername: "mathys-ottenwaelter",
  },

  hero: {
    eyebrow: "Développeur full-stack · Toulouse",
    title: "Mathys Waelter",
    subtitle:
      "Un seul interlocuteur pour votre produit web : React / Next.js côté interface, Node.js côté API, déploiement inclus. Idéal pour MVP, outils métier et sites qui convertissent.",
    primaryCTA: "Parler de votre projet",
    secondaryCTA: "Voir mes réalisations",
  },

  about: {
    eyebrow: "Qui je suis",
    title: "À propos",
    paragraphs: [
      "Freelance full-stack à Toulouse. Je construis des apps web pour PME et startups — de l’interface à la mise en production, sans couche d’agence.",
      "Un MVP utile d’abord, puis des itérations. Performance, SEO technique et code que vous pouvez reprendre font partie du deal.",
    ],
  },

  process: [
    {
      step: "01",
      title: "Brief & devis",
      description: "Besoin, périmètre, budget. Proposition sous 48h.",
    },
    {
      step: "02",
      title: "Prototype",
      description: "Une première version pour valider la direction.",
    },
    {
      step: "03",
      title: "Développement",
      description: "Livraisons courtes, feedback régulier.",
    },
    {
      step: "04",
      title: "Mise en prod",
      description: "Déploiement, relais, maintenance si besoin.",
    },
  ],

  services: [
    {
      id: 1,
      title: "Site vitrine & refonte",
      description:
        "Site clair, rapide et orienté contact : landing, vitrine PME, refonte. SEO technique de base et mise en ligne inclus.",
      icon: "code-bracket",
      color: "cyan",
      deliverables: ["Design responsive", "Formulaire / CTA", "Déploiement"],
    },
    {
      id: 2,
      title: "Application web & MVP",
      description:
        "Produit sur mesure de bout en bout : auth, tableaux de bord, API, rôles. Parfait pour tester une idée ou digitaliser un process métier.",
      icon: "server",
      color: "purple",
      deliverables: ["Front + API", "Base de données", "Mise en production"],
    },
    {
      id: 3,
      title: "E-commerce & paiements",
      description:
        "Boutique ou tunnel d’achat avec Stripe, catalogue, admin et stock. Pensé pour convertir et rester maintenable.",
      icon: "chart-bar",
      color: "green",
      deliverables: ["Catalogue", "Paiement sécurisé", "Espace admin"],
    },
    {
      id: 4,
      title: "Maintenance & évolutions",
      description:
        "Corrections, nouvelles features, perf et sécurité. Un interlocuteur unique pour faire vivre votre produit après le lancement.",
      icon: "wrench-screwdriver",
      color: "blue",
      deliverables: ["Support", "Évolutions", "Monitoring"],
    },
  ],

  technologies: {
    frontend: ["React", "Next.js", "TypeScript", "Tailwind CSS"],
    backend: ["Node.js", "Express.js", "PostgreSQL", "MongoDB"],
    tools: ["Git", "Docker", "Vercel", "AWS"],
  },

  projects: [
    {
      id: 1,
      name: "Enelana Pharma",
      sector: "Pharma / B2B",
      description:
        "Plateforme web pour un commercial multi-carte dans le Sud-Ouest : offres produits, catalogues marques et accès pharmacies (inscription / connexion).",
      problem:
        "Les pharmacies avaient besoin d’un accès clair à l’offre et d’un parcours digital digne d’un acteur B2B, sans outil lourd.",
      result:
        "Site live en production — vitrine premium, auth, catalogues et ancrage local (4 départements, 50+ marques).",
      role: "Conception & développement full-stack, UI et mise en ligne.",
      technologies: ["React", "JavaScript", "PostgreSQL", "Node.js"],
      image: "ENELANAFRONT.webp",
      link: "https://enelana.com/",
      featured: true,
    },
    {
      id: 2,
      name: "Domaine de Dampierre",
      sector: "Hospitality / Événements",
      description:
        "Site vitrine premium pour un domaine événementiel à Buzet-sur-Tarn (près de Toulouse) : mariages, séminaires, shootings et séjours.",
      problem:
        "Le lieu manquait d’une présence digitale à la hauteur : il fallait donner envie et convertir les demandes en prises de contact.",
      result:
        "Site live immersif — storytelling du domaine, offres claires (privé / pro / shooting) et parcours contact fluide.",
      role: "Conception & développement de la vitrine, de l’identité visuelle web à la mise en ligne.",
      technologies: ["React", "TypeScript", "Vite", "Framer Motion"],
      image: "DAMPIERRE.webp",
      link: "https://www.domaine-de-dampierre.fr/",
      featured: true,
    },
    {
      id: 3,
      name: "Ev'Hunt",
      sector: "Events / Marketplace",
      description:
        "Plateforme de découverte d’événements à Toulouse : carte, filtres, billets QR et revente face-value avec commission transparente (8%).",
      problem:
        "Trouver concerts, clubs et festivals rapidement, avec billets sécurisés et une revente fiable.",
      result:
        "Produit web dark mode (launch 2026) : recherche, map, filtres et parcours billetterie unifiés.",
      role: "Product design & développement full-stack (front + API).",
      technologies: ["React", "Next.js", "TypeScript", "Node.js"],
      image: "EHFIRST.webp",
      link: "",
      featured: true,
    },
    {
      id: 4,
      name: "Essential Love Room",
      sector: "Hospitality",
      description:
        "Site vitrine & conversion pour une love room à Léguevin (20 min de Toulouse) : suite, galerie, avis et réservation.",
      problem:
        "Convertir le trafic en réservations avec une image premium et un parcours simple sur mobile comme desktop.",
      result:
        "Landing immersive en production — hero full-bleed, CTA réservation et navigation claire.",
      role: "Design & développement front, déploiement du site.",
      technologies: ["React", "TypeScript", "Tailwind CSS"],
      image: "ELFIRST.webp",
      link: "https://essential-love.fr/",
      featured: true,
    },
    {
      id: 5,
      name: "GameShop",
      sector: "E-commerce",
      description:
        "Boutique en ligne de jeux vidéo : catalogue, panier, paiement Stripe, stocks et back-office admin.",
      problem:
        "Besoin d’un e-commerce complet (paiement + admin) sans rester bloqué sur une solution no-code limitée.",
      result:
        "Parcours d’achat bout-en-bout avec gestion catalogue / stocks côté admin.",
      role: "Full-stack : React storefront, API Node, Stripe.",
      technologies: ["React", "Node.js", "MongoDB", "Stripe", "Express"],
      image: "gameshop.webp",
      link: "",
      featured: false,
    },
    {
      id: 6,
      name: "TCG Collection Manager",
      sector: "Produit web",
      description:
        "Application pour gérer une collection de cartes : recherche, statistiques et estimation de valeur.",
      problem:
        "Suivre une collection dispersée sans tableur illisible ni outil générique.",
      result:
        "App temps réel avec stats et recherche pour piloter sa collection.",
      role: "Full-stack Vue + Express + MongoDB.",
      technologies: ["Vue.js", "Express", "MongoDB", "Chart.js", "Socket.io"],
      image: "tcgcollector.webp",
      link: "",
      featured: false,
    },
    {
      id: 7,
      name: "SentenceSimilarity AI",
      sector: "IA / API",
      description:
        "API et interface de test pour mesurer la similarité sémantique entre phrases.",
      problem:
        "Comparer le sens de textes au-delà d’une simple correspondance de mots-clés.",
      result:
        "Modèle exposé en API REST avec UI de démonstration.",
      role: "Data / backend Python (modèle + API Flask).",
      technologies: ["Python", "TensorFlow", "Flask", "Scikit-learn"],
      image: "sentence-similarity.webp",
      link: "",
      featured: false,
    },
  ],

  contact: {
    title: "Parlons de votre projet",
    subtitle:
      "Décrivez votre besoin en quelques lignes, ou réservez 15 minutes directement dans mon agenda. Réponse sous 24–48h.",
    buttonText: "Envoyer le message",
    formTitle: "Décrire mon projet",
    calCta: "Réserver un appel",
  },

  stats: [
    { label: "Années d'expérience", value: "3+" },
    { label: "Projets livrés", value: "10+" },
    { label: "Interlocuteur", value: "1 seul" },
  ],

  techCategories: [
    {
      name: "Front-End",
      technologies: [
        { name: "React", count: 47 },
        { name: "TypeScript", count: 42 },
        { name: "Next.js", count: 35 },
        { name: "Tailwind CSS", count: 40 },
      ],
    },
    {
      name: "Back-End",
      technologies: [
        { name: "Node.js", count: 45 },
        { name: "Express", count: 38 },
        { name: "PostgreSQL", count: 25 },
        { name: "MongoDB", count: 30 },
      ],
    },
    {
      name: "Outils",
      technologies: [
        { name: "Git", count: 50 },
        { name: "Docker", count: 29 },
        { name: "Vercel", count: 34 },
        { name: "AWS", count: 23 },
      ],
    },
  ],

  values: [
    {
      title: "Un seul interlocuteur",
      description: "UI, API, BDD et mise en ligne : je gère le cycle complet.",
    },
    {
      title: "Livraison utile",
      description: "Priorité au MVP qui marche, puis itérations selon vos retours.",
    },
    {
      title: "Code durable",
      description: "Stack moderne, code lisible, doc minimale pour reprendre la main.",
    },
    {
      title: "Com’ claire",
      description: "Devis transparent, délais réalistes, points réguliers.",
    },
  ],
};

export interface Service {
  id: number;
  title: string;
  description: string;
  icon: string;
  color: string;
  deliverables?: string[];
}

export interface Project {
  id: number;
  name: string;
  sector?: string;
  description: string;
  problem?: string;
  result?: string;
  role?: string;
  technologies: string[];
  image: string;
  link: string;
  featured: boolean;
}

export interface Technology {
  name: string;
  count: number;
}

export interface TechnologyCategory {
  name: string;
  technologies: Technology[];
}

export interface Technologies {
  frontend: string[];
  backend: string[];
  tools: string[];
}
